import React, { useEffect, useState } from 'react'
import './dataTableMessages.scss'
import { DataGrid } from '@mui/x-data-grid';
import { messageColumns } from '../../data/dataSource';
import { Link } from 'react-router-dom';
import { collection, getDocs,  deleteDoc, doc, onSnapshot, query, orderBy, where, writeBatch, addDoc } from "firebase/firestore";
import { db, storage  } from '../../firebase'
import { ref, uploadBytesResumable, getDownloadURL, uploadBytes } from "firebase/storage";
import ConfirmBox from '../ConfirmBox';
import { Select, MenuItem, FormControl, InputLabel, TextField, Button, Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { useNavigate } from "react-router-dom"
import WarningAmber from '@mui/icons-material/WarningAmber';
import Icon from '@mui/material/Icon';
import UploadIcon from '@mui/icons-material/Upload';


const DataTable = () => {

  const [logo, setLogo] = useState("")

  const [caption, setCaption] = useState("")

  const [heropic, setHeropic] = useState("")

  const [facebookicon, setFacebookicon] = useState("")

  const [instaicon, setInstaicon] = useState("")

  const [tiktokicon, setTiktokicon] = useState("")

  const [linkedinicon, setLinkedinicon] = useState("")

  const [twittericon, setTwittericon] = useState("")

  const [herotext, setHerotext] = useState("")

  const [subheading, setSubheading] = useState("")

  const [nuggets, setNuggets] = useState([])

  const [ data, setData ] = useState({})

  // const [file, setFile ] = useState("")

  const [ perc, setPerc ] = useState(null)

  const [percimage, setPercimage] = useState(null)




  ////////////////////////////  GOOD ONE //////////////////////////////////

  const [inputFields, setInputFields] = useState([{ id: 1, textValue: '', file: null }]);



      const handleAddInput = () => {
        setInputFields([...inputFields, { id: inputFields.length + 1, textValue: '', file: null }]);
      };

      const handleRemoveInput = (index) => { 
        const newFields = [...inputFields];
        newFields.splice(index, 1);
        setInputFields(newFields);
      };

      const handleChange = (index, event) => {
        const { name, value, files } = event.target;
        const newFields = [...inputFields];
        if (name === 'file') {
          newFields[index].file = files[0]; // Store the File object

        } else {
          newFields[index][name] = value;
        }
        setInputFields(newFields);
      };


    const uploadFile = async (file) => {
      if (!file) return null;
      const storageRef = ref(storage, `uploads/${file.name}`);
      await uploadBytes(storageRef, file);
      return getDownloadURL(storageRef); // Get the public URL
    };


///////////////////.  END GOOD ONE  ////////////////////////////////////




    /////////////////////////////////////

  const [isloading, setIsloading ] = useState(false)

  const today = new Date().toDateString()

  const navigate = useNavigate();


  const Spinner = () => {
    return(
      <div className='spinner-container'>
          <div className='loading-spinner'></div>
      </div>
    )
  }


  const SpinnerLoad = () => {
    return(
      <div className='spinner-containerLoad'>
          <div className='loading-spinnerLoad'></div>
      </div>
    )
  }

  

    useEffect(() => {

      const uploadFile = () => {
  
        const name = new Date().getTime() + logo.name;
        
        const storageRef = ref(storage, name);
  
        const uploadTask = uploadBytesResumable(storageRef, logo);
  
        uploadTask.on('state_changed', 

          (snapshot) => {
          
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

            console.log('Upload is ' + progress + '% done');

            setPerc(progress)
            
            switch (snapshot.state) {
              case 'paused':
                console.log('Upload is paused');
                break;
              case 'running':
                console.log('Upload is running');
                break;
              default:
                break;
            }
          }, 
          (error) => {
            console.log(error)
          }, 
          () => {
           
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

            setData((prev) => ({...prev, logo: downloadURL}))

          });
          }
        );
  
      };
  
      logo && uploadFile();
  
    }, [logo]);



      useEffect(() => {

      const uploadFilehero = () => {
  
        const name = new Date().getTime() + heropic.name;
        
        const storageRef = ref(storage, name);
  
        const uploadTask = uploadBytesResumable(storageRef, heropic);
  
        uploadTask.on('state_changed', 

          (snapshot) => {
          
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

            console.log('Upload is ' + progress + '% done');

            setPercimage(progress)
            
            switch (snapshot.state) {
              case 'paused':
                console.log('Upload is paused');
                break;
              case 'running':
                console.log('Upload is running');
                break;
              default:
                break;
            }
          }, 
          (error) => {
            console.log(error)
          }, 
          () => {
           
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

            setData((prev) => ({...prev, heropic: downloadURL}))

          });
          }
        );
  
      };
  
      heropic && uploadFilehero();
  
    }, [heropic]);


/// ICONS UPLOAD. ////


  useEffect(() => {

      const uploadFileFace = () => {
  
        const name = new Date().getTime() + facebookicon.name;
        
        const storageRef = ref(storage, name);
  
        const uploadTask = uploadBytesResumable(storageRef, facebookicon);
  
        uploadTask.on('state_changed', 

          (snapshot) => {
          
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

            console.log('Upload is ' + progress + '% done');

          }, 
          (error) => {
            console.log(error)
          }, 
          () => {
           
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

            setData((prev) => ({...prev, facebookicon: downloadURL}))

          });
          }
        );
  
      };
  
      facebookicon && uploadFileFace();
  
  }, [facebookicon]);



   useEffect(() => {

      const uploadFileInsta = () => {
  
        const name = new Date().getTime() + facebookicon.name;
        
        const storageRef = ref(storage, name);
  
        const uploadTask = uploadBytesResumable(storageRef, instaicon);
  
        uploadTask.on('state_changed', 

          (snapshot) => {
          
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

            console.log('Upload is ' + progress + '% done');

          }, 
          (error) => {
            console.log(error)
          }, 
          () => {
           
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

            setData((prev) => ({...prev, instaicon: downloadURL}))

          });
          }
        );
  
      };
  
      instaicon && uploadFileInsta();
  
  }, [instaicon]);



   useEffect(() => {

      const uploadFileTik = () => {
  
        const name = new Date().getTime() + tiktokicon.name;
        
        const storageRef = ref(storage, name);
  
        const uploadTask = uploadBytesResumable(storageRef, tiktokicon);
  
        uploadTask.on('state_changed', 

          (snapshot) => {
          
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

            console.log('Upload is ' + progress + '% done');

          }, 
          (error) => {
            console.log(error)
          }, 
          () => {
           
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

            setData((prev) => ({...prev, tiktokicon: downloadURL}))

          });
          }
        );
  
      };
  
      tiktokicon && uploadFileTik();
  
  }, [tiktokicon]);


 useEffect(() => {

      const uploadFileLinked = () => {
  
        const name = new Date().getTime() + linkedinicon.name;
        
        const storageRef = ref(storage, name);
  
        const uploadTask = uploadBytesResumable(storageRef, linkedinicon);
  
        uploadTask.on('state_changed', 

          (snapshot) => {
          
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

            console.log('Upload is ' + progress + '% done');


          }, 
          (error) => {
            console.log(error)
          }, 
          () => {
           
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

            setData((prev) => ({...prev, linkedinicon: downloadURL}))

          });
          }
        );
  
      };
  
      linkedinicon && uploadFileLinked();
  
  }, [linkedinicon]);


    
   useEffect(() => {

      const uploadFileTwit = () => {
  
        const name = new Date().getTime() + twittericon.name;
        
        const storageRef = ref(storage, name);
  
        const uploadTask = uploadBytesResumable(storageRef, twittericon);
  
        uploadTask.on('state_changed', 

          (snapshot) => {
          
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

            console.log('Upload is ' + progress + '% done');

    
          }, 
          (error) => {
            console.log(error)
          }, 
          () => {
           
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

            setData((prev) => ({...prev, twittericon: downloadURL}))

          });
          }
        );
  
      };
  
      twittericon && uploadFileTwit();
  
  }, [twittericon]);



  /////////////  


 
  
    console.log(data)


 
    
      const handleAdd = async(e) => {
    
           e.preventDefault()

             const dataToSave = [];
              for (const field of inputFields) {
                const fileUrl = await uploadFile(field.file); // Upload file and get URL
                dataToSave.push({
                  guidelinetext: field.textValue,
                  file: fileUrl,
                });

      }

           setIsloading(true)
    
           try {

             const docRef = await addDoc(collection(db, "analythics"), {
    
              caption : caption,

              herotext : herotext,

              subheading : subheading,

              ...data,

              dataToSave


             })

             setIsloading(false)
            
           } catch (error) {

             console.log(error)
            
           }
          
           
      }
    
 

  return (

     <>    
          <div className="datatable">
          <div className='datatableTitle'>
            <Link to="/analythics/view"  style={{textDecoration:"none"}} >
              <div className='link'>
                Preview Analythics Email
              </div>
            </Link>

              <h3 className=''>Monthly Subscribers Analytic Email</h3>  
                
            {/* <Link to="/messages/new"  style={{textDecoration:"none"}} > */}
              <div className=''>
                {/* Update Analythics Email */}
              </div>
            {/* </Link> */}
           
          </div>

           <div style={{flex:1}}>
                      <div style={{
                        display: 'flex',
                        gap: 30,
                        alignItems: 'center',
                        justifyContent: 'center', 
                        padding: 20,
                        flexDirection: 'column'
                      }} 
                      
                      onSubmit={handleAdd}>
          
                             {/* <Box sx={{ minWidth: '50%' }}>
                              <FormControl fullWidth>
                              <InputLabel id="plan" style={{color:'#999', fontWeight:300}}>Select Subscriber Type</InputLabel>
                              <Select
                                labelId="plan"
                                id="plan"
                                value={plan}
                                label="Plan"
                                onChange={handleChange}
                              
                              >
          
                                {selectoptions.map((item) => { 
          
                                  return(
          
                                    <MenuItem value={item.value}>{item.label}</MenuItem>
          
                                  ) 
                                })}
          
                              </Select>
                              </FormControl>
                            </Box> */}
                                     
                            {/* <Box sx={{ minWidth: '50%' }}>
                              <FormControl fullWidth>
                              <InputLabel id="icon" style={{color:'#999', fontWeight:300}}>Select Message Icon</InputLabel>
                              <Select
                                labelId="icon"
                                id="icon"
                                value={icon}
                                label="Icon"
                                onChange={handleChangeIcon}
                            
                              >
          
                                {selectIcon.map((item) => { 
          
                                  return(
          
                                    <MenuItem value={item.value}>
                                      {item.label}
                                    </MenuItem>
          
                                  ) 
                                })}
          
                              </Select>
                              </FormControl>
                            </Box> */}
                    
                            {/* <Box sx={{ minWidth: '50%' }}>
                              <FormControl fullWidth>
                              <InputLabel id="icon" style={{color:'#999', fontWeight:300}}>Select Icon Color</InputLabel>
                              <Select
                                labelId="color"
                                id="color"
                                value={iconColor}
                                label="Icon Color"
                                onChange={handleChangeIconColor}
                          
                              >
          
                                {selectColor.map((item) => { 
          
                                  return(
          
                                    <MenuItem value={item.value}>
                                      
                                      <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center', gap:40}}>
                                          {item.label}
                                          <div style={{width:20, height:20, backgroundColor:item.code}}></div>
                                      </div>
                                    </MenuItem>
          
                                  ) 
                                })}
          
                              </Select>
                              </FormControl>
                            </Box> */}

                            {/* <TextField
                              id="title"
                              onChange={(e) => setTitle(e.target.value)}
                              value = {title}
                              placeholder="Enter Title"
                              style={{width:'50%'}}        
                            /> */}
                            
                            <div style={{display:'flex', width:680, height:200, backgroundColor:'#eee', borderRadius:20, borderWidth: 5, borderColor:'#000', flexDirection:'row', alignItems: 'center', justifyContent: 'space-around'}}>

                              <div style={{display: 'flex', flexDirection: 'column', gap: 50, alignItems:'center'}}>
                                <h3 style={{color:'gray'}}>Upload Chillaxia Logo</h3>
                                <label htmlFor='logo'>
                                  <div style={{width:120, height:80, justifyContent:'center', borderRadius:10, alignItems:'center', display:'flex', border: '1px solid gray', cursor:'pointer'}}>
                                      <UploadIcon style={{width:40, height:40, color:'#333'}}/>
                                  </div>
                                 <input type="file" id="logo" onChange= {e => setLogo(e.target.files[0])} style={{display:'none'}}/>
                                  
                                </label>
                              </div>

                              <div style={{width:140, height:140, border:'1px dashed gray', borderRadius: 20}}>

                                  {perc !== null && perc < 100
                                  
                                    ?

                                    <SpinnerLoad/>

                                    :

                                     logo &&

                                    <img
                                      src={ URL.createObjectURL(logo)}
                                      alt="logo"
                                      width={140} 
                                      height={140}
                                      resizeMode = "contain"
                                      style={{display: 'flex', justifyContent:'center', alignItems: 'center', paddingLeft:3}}
                                    />

                                    }

                                  
                                
                              </div>
                            </div>
                              
          
                            <TextField
                              id="caption" 
                              value={caption}
                              multiline
                              minRows={1}
                              maxRows={3}
                              placeholder="Enter Caption"
                              style={{width:'50%', fontSize:40}}
                              onChange={(e) => setCaption(e.target.value)}
                            />

                            <TextField
                              id="herotext" 
                              value={herotext}
                              multiline
                              minRows={2}
                              maxRows={4}
                              placeholder="Enter Hero Text"
                              style={{width:'50%'}}
                              onChange={(e) => setHerotext(e.target.value)}
                            />
{/* 
                             const [heroimage, setHeroimage] = useState(null)
                             const [percimage, setPercimage] = useState(null) */}

                             <div style={{display:'flex', width:680, height:200, backgroundColor:'#eee', borderRadius:20, borderWidth: 5, borderColor:'#000', flexDirection:'row', alignItems: 'center', justifyContent: 'space-around'}}>

                              <div style={{display: 'flex', flexDirection: 'column', gap: 50, alignItems:'center'}}>
                                <h3 style={{color:'gray'}}>Upload Hero Image</h3>
                                <label htmlFor='heropic'>
                                  <div style={{width:120, height:80, justifyContent:'center', borderRadius:10, alignItems:'center', display:'flex', border: '1px solid gray', cursor:'pointer'}}>
                                      <UploadIcon style={{width:40, height:40, color:'#333'}}/>
                                  </div>
                                 <input type="file" id="heropic" onChange= {e => setHeropic(e.target.files[0])} style={{display:'none'}}/>
                                  
                                </label>
                              </div>
                              
                              <div style={{width:140, height:140, border:'1px dashed gray', borderRadius: 20}}>

                                  {percimage !== null && percimage < 100
                                  
                                    ?

                                    <SpinnerLoad/>

                                    :

                                     heropic &&
                                     
                                    <img
                                      src={ URL.createObjectURL(heropic)}
                                      alt="pic"
                                      width={140} 
                                      height={140}
                                      resizeMode = "contain"
                                      style={{display: 'flex', justifyContent:'center', alignItems: 'center', paddingLeft:3}}
                                    />

                                  }
                                
                              </div>
                             </div>



                            <TextField
                              id="subheading" 
                              value={subheading}
                              multiline
                              minRows={2}
                              maxRows={3}
                              placeholder="Enter Sub Heading"
                              style={{width:'50%'}}
                              onChange={(e) => setSubheading(e.target.value)}
                            />

                            <div style={{display: 'flex', flexDirection:'column', gap:20}}>
                            {inputFields.map((field, index) => (
                           
                            <div  key={index} style={{display:'flex', flexDirection:'column', backgroundColor:'#eee'}}>

                            {inputFields.length > 1 && (
                             <button onClick={() => handleRemoveInput(index)} style={{padding:20, backgroundColor:'red', color:'white', borderRadius:10, fontSize:15, alignSelf:'flex-end', marginTop:20, marginRight:20}}>X
                            </button>)}

                              <div style={{display:'flex', width:680, height:200, backgroundColor:'#eee', borderRadius:20, borderWidth: 5, borderColor:'#000', flexDirection:'row', alignItems: 'center', justifyContent: 'space-around'}}>

                              <div style={{display: 'flex', flexDirection: 'column', gap: 10, alignItems:'center'}}>
                                <h3 style={{color:'gray'}}>Guideline { field.id}</h3>
                                <label htmlFor='field.file'>
                                  <div style={{width:40, height:40, justifyContent:'center', borderRadius:10, alignItems:'center', display:'flex', border: '1px solid gray', cursor:'pointer'}}>
                                      <UploadIcon style={{width:20, height:20, color:'#333'}}/>
                                  </div>
                                 <input type="file" name="file" id="field.file" onChange={(e) => handleChange(index, e)} style={{display:'none'}}/>
                                  
                                </label>

                                {/* {
                                       field.file &&
                                     
                                    <img
                                      src={ URL.createObjectURL(field.file)}
                                      alt="pic"
                                      width={50} 
                                      height={50}
                                      resizeMode = "contain"
                                      style={{display: 'flex', justifyContent:'center', alignItems: 'center', paddingLeft:3}}
                                    />
                                } */}

                                 {/* <img
                                      src={inputFields.file
                                        ? URL.createObjectURL(inputFields.file) 
                                        : <h2></h2>
                                      }
                                      alt=""
                                      width={50} 
                                      height={50}
                                      resizeMode = "contain"
                                      style={{display: 'flex', justifyContent:'center', alignItems: 'center', paddingLeft:10}}
                                    /> */}


                              </div>
                              
                             <div style={{display: 'flex', width: '60%'}}>

                              <TextField
                                value={field.textValue}
                                name='textValue'
                                multiline
                                minRows={2}
                                maxRows={3}
                                placeholder="Enter Guideline"
                                style={{width:'100%', backgroundColor: 'white'}}
                                onChange={(e) => handleChange(index, e)}
                              />

                              

                             </div>
                            </div>

                            </div>
                           

                             ))}

                              <button onClick={() => handleAddInput()} style={{padding:20, backgroundColor:'#9BDDFF', color:'black', borderRadius:10, fontSize:18}}>Add Guidelines</button>
                            </div>

                             


                             {/* BEGIN */}


                              {/* {inputFields.map((field, index) => (
                                <div key={index}>
                                  <input
                                    type="text"
                                    name="textValue"
                                    value={field.textValue}
                                    onChange={(e) => handleChange(index, e)}
                                  style={{width:'100%', backgroundColor: 'white'}}
                                    
                                  />
                                  <input
                                    type="file"
                                    name="file"
                                    onChange={(e) => handleChange(index, e)}
                                  />
                                  {inputFields.length > 1 && (
                                    <button type="button" onClick={() => handleRemoveInput(index)}>
                                      Remove
                                    </button>
                                  )}
                                </div>
                              ))}
                              <button type="button" onClick={handleAddInput}>
                                Add Input
                              </button> */}



                             {/* END */}










                             <div style={{display:'flex', width:680, height:400, backgroundColor:'#eee', borderRadius:20, borderWidth: 5, borderColor:'#000', flexDirection:'row', alignItems: 'center', justifyContent: 'space-around', flexWrap: 'wrap', padding:20}}>

                              <div style={{display: 'flex', flexDirection: 'column', gap: 20, alignItems:'center', width: 200}}>
                                <h3 style={{color:'gray'}}>Upload Facebook</h3>
                                <label htmlFor='facebookicon'>
                                  <div style={{width:50, height:50, justifyContent:'center', borderRadius:10, alignItems:'center', display:'flex', border: '1px solid gray', cursor:'pointer'}}>
                                      <UploadIcon style={{width:40, height:40, color:'#333'}}/>
                                  </div>
                                 <input type="file" id="facebookicon" onChange= {e => setFacebookicon(e.target.files[0])} style={{display:'none'}}/>
                                  
                                </label>

                                { facebookicon &&
                                <img
                                  src={ URL.createObjectURL(facebookicon)}
                                  alt="facebook"
                                  width={30} 
                                  height={30}
                                  resizeMode = "contain"
                                  style={{display: 'flex', justifyContent:'center', alignItems: 'center', paddingLeft:10}}
                                />

                                }
                             
                              </div>


                              <div style={{display: 'flex', flexDirection: 'column', gap: 20, alignItems:'center'}}>
                                <h3 style={{color:'gray'}}>Upload Instagram</h3>
                                <label htmlFor='instaicon'>
                                  <div style={{width:50, height:50, justifyContent:'center', borderRadius:10, alignItems:'center', display:'flex', border: '1px solid gray', cursor:'pointer'}}>
                                      <UploadIcon style={{width:40, height:40, color:'#333'}}/>
                                  </div>
                                 <input type="file" id="instaicon" onChange= {e => setInstaicon(e.target.files[0])} style={{display:'none'}}/>
                                  
                                </label>

                                { instaicon &&
                                <img
                                  src={ URL.createObjectURL(instaicon)}
                                  alt="instagram"
                                  width={30} 
                                  height={30}
                                  resizeMode = "contain"
                                  style={{display: 'flex', justifyContent:'center', alignItems: 'center', paddingLeft:10}}
                                />

                                }
                              </div>


                                <div style={{display: 'flex', flexDirection: 'column', gap: 20, alignItems:'center'}}>
                                <h3 style={{color:'gray'}}>Upload Tiktok </h3>
                                <label htmlFor='tiktokicon'>
                                  <div style={{width:50, height:50, justifyContent:'center', borderRadius:10, alignItems:'center', display:'flex', border: '1px solid gray', cursor:'pointer'}}>
                                      <UploadIcon style={{width:40, height:40, color:'#333'}}/>
                                  </div>
                                 <input type="file" id="tiktokicon" onChange= {e => setTiktokicon(e.target.files[0])} style={{display:'none'}}/>
                                  
                                </label>

                                { tiktokicon &&
                                <img
                                  src={ URL.createObjectURL(tiktokicon)}
                                  alt="tiktok"
                                  width={30} 
                                  height={30}
                                  resizeMode = "contain"
                                  style={{display: 'flex', justifyContent:'center', alignItems: 'center', paddingLeft:10}}
                                />

                                }
                              </div>

                              <div style={{display: 'flex', flexDirection: 'column', gap: 20, alignItems:'center'}}>
                                <h3 style={{color:'gray'}}>Upload Linkedin</h3>
                                <label htmlFor='linkedin'>
                                  <div style={{width:50, height:50, justifyContent:'center', borderRadius:10, alignItems:'center', display:'flex', border: '1px solid gray', cursor:'pointer'}}>
                                      <UploadIcon style={{width:40, height:40, color:'#333'}}/>
                                  </div>
                                 <input type="file" id="linkedin" onChange= {e => setLinkedinicon(e.target.files[0])} style={{display:'none'}}/>
                                  
                                </label>

                                { linkedinicon &&
                                <img
                                  src={ URL.createObjectURL(linkedinicon)}
                                  alt="linkedin"
                                  width={30} 
                                  height={30}
                                  resizeMode = "contain"
                                  style={{display: 'flex', justifyContent:'center', alignItems: 'center', paddingLeft:10}}
                                />

                                }
                              </div>


                             <div style={{display: 'flex', flexDirection: 'column', gap: 20, alignItems:'center'}}>
                                <h3 style={{color:'gray'}}>Upload Twitter</h3>
                                <label htmlFor='twittericon'>
                                  <div style={{width:50, height:50, justifyContent:'center', borderRadius:10, alignItems:'center', display:'flex', border: '1px solid gray', cursor:'pointer'}}>
                                      <UploadIcon style={{width:40, height:40, color:'#333'}}/>
                                  </div>
                                 <input type="file" id="twittericon" onChange= {e => setTwittericon(e.target.files[0])} style={{display:'none'}}/>
                                  
                                </label>

                                { twittericon &&
                                <img
                                  src={ URL.createObjectURL(twittericon)}
                                  alt="twitter"
                                  width={30} 
                                  height={30}
                                  resizeMode = "contain"
                                  style={{display: 'flex', justifyContent:'center', alignItems: 'center', paddingLeft:10}}
                                />

                                }
                              </div>


                             </div>


                          <Button onClick={handleAdd} style={{width:'50%', height:60, paddingTop: 10, paddingBottom: 10, backgroundColor:'blue'}}>
                          {/* {isloading ? <Spinner/>: <h4 style = {{color: 'white'}}>Submit</h4>} */}
                            {isloading && <span style={{color:'white'}}>...</span>}
                            {isloading ? <h3 style={{color:'white'}}>loading</h3> : <h3 style = {{color: 'white'}}>Submit</h3>}
                          
                          </Button>
          
                       {/* <button disabled={perc !== null && perc < 100} type='submit' >Submit</button> */}
          
                      </div>
                    </div>
      
        </div>
         {/* <ConfirmBox
         open={open}
         closeDialog={() => setOpen(false)}
         // title={deleteData?.name}
         deleteFunction={handleDelete}
         /> */}
        
        </>

  )
}

export default DataTable